/*
 *
 * BlockedModal
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
 */

import PortalTextLink from '@nexidigital/portaltextlink'
import React from 'react'
import { openUrl } from 'Utility/globalMethods'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  // Modal for 24-hour blocked user
  blockedModal24HoursTitle: (
    <PortalMessage
      id='t.app.blockedModal.24Hours.title'
      defaultMessage='La tua utenza è stata bloccata <br/> per 24 ore'
    />
  ),
  blockedModal24HoursDescription: (
    <PortalMessage
      id='t.app.blockedModal.24Hours.description'
      defaultMessage='Hai effettuato 5 tentativi errati, di conseguenza la tua utenza è stata bloccata. <br />
      Per poter resettare la tua password contatta il servizio clienti o attendi 24 ore.'
    />
  ),

  // Modal for blocked user
  blockedModalTitle: <PortalMessage id='t.app.blockedModal.title' defaultMessage='La tua utenza è stata bloccata' />,
  blockedModalDescription: (
    <PortalMessage
      id='t.app.blockedModal.description'
      defaultMessage='Per motivi di sicurezza, la tua utenza è stata bloccata. <br />
    Per poter riattivare la tua utenza contatta il servizio clienti.'
    />
  ),

  // Modal for user not valid
  blockedModalUserNotValidTitle: (
    <PortalMessage id='t.app.blockedModal.userNotValid.title' defaultMessage='Utenza non valida' />
  ),
  blockedModalUserNotValidDescription: (
    <PortalMessage
      id='t.app.blockedModal.userNotValid.description'
      defaultMessage='La tua utenza non è più valida. <br />
    Per ricevere informazioni aggiuntive contatta il servizio clienti.'
    />
  ),

  // Modal for service not available
  blockedModalServiceNotAvailableTitle: (
    <PortalMessage
      id='t.app.blockedModal.serviceNotAvailable.title'
      defaultMessage='In questo momento il servizio non è disponibile'
    />
  ),
  blockedModalServiceNotAvailableDescription: (
    <PortalMessage
      id='t.app.blockedModal.serviceNotAvailable.description'
      defaultMessage='Riprova più tardi oppure contatta il servizio clienti.'
    />
  ),

  // Modal for service not available
  blockedModalAccountDisabledTitle: (
    <PortalMessage
      id='t.app.shared.registration.blocked'
      defaultMessage='Impossibile procedere con la registrazione'
    />
  ),
  blockedModalAccountDisabledDescription: (
    <PortalMessage
      id='t.app.blockedModal.AccountDisabled.description'
      defaultMessage='La partita IVA o il codice fiscale digitato risulta non valido. Ti chiediamo di contattare il Servizio Clienti.'
    />
  ),

  // Contact center numbers
  contactLabel: <PortalMessage id='t.app.contactLabel' defaultMessage='Numero Assistenza' />,
  contactNumber: <PortalMessage id='t.app.contactNumber' defaultMessage='+39 02345448' />,
  contactHoursAuto: (
    <PortalMessage
      id='t.app.contactHoursAuto'
      defaultMessage='Servizi automatici: <strong>24 ore su 24, 365 giorni</strong> l’anno'
    />
  ),
  contactHoursOperator: (
    <PortalMessage
      id='t.app.contactHoursOperator'
      defaultMessage='Servizi con operatore: <strong>08:00 - 20:00, lunedì - venerdì</strong>'
    />
  ),

  labelButton: <PortalMessage id='t.app.close' defaultMessage='Chiudi' />,
  labelButtonExit: <PortalMessage id='t.app.logout' defaultMessage='Esci' />,

  understandButton: (
    <PortalMessage
      id='t.app.registration.confirmPhone.error.expiredCodeModal.buttonLabel'
      defaultMessage='Ok, Ho Capito'
    />
  ),

  regVatEmailAppemptsErrorModalTitle: (
    <PortalMessage
      id='t.app.shared.registration.blocked'
      defaultMessage='Impossibile procedere con la registrazione'
    />
  ),
  regVatEmailAppemptsErrorModalDescription: (
    <PortalMessage
      id='t.app.registration.regVatEmailAppemptsErrorModal.description'
      defaultMessage='Hai esaurito i tentativi di registrazione per oggi. Riprova tra 24 ore.'
    />
  ),

  appOfflineModalTitle: (
    <PortalMessage
      id='t.app.errorModal.appOfflineModalTitle'
      defaultMessage='Connessione assente'
    />
  ),
  appOfflineModalDescription: (
    <PortalMessage
      id='t.app.errorModal.appOfflineModalDescription'
      defaultMessage='Forse non sei collegato a una rete. Controlla la connessione internet del tuo smartphone.'
    />
  ),
  tryAgain: (
    <PortalMessage
      id='t.app.tryAgain'
      defaultMessage='Riprova'
    />
  ),
  appToUpdateModalTitle: (
    <PortalMessage
      id='t.app.errorModal.appToUpdateModalTitle'
      defaultMessage='Ops...'
    />
  ),
  appToUpdateModalDescription: (
    <PortalMessage
      id='t.app.errorModal.appToUpdateModalDescription'
      defaultMessage='L’app Nexi Business <strong>non è disponibile al momento.</strong><br /><br />Vai allo Store e scarica la nuova versione.'
    />
  ),
  goToStore: (
    <PortalMessage
      id='t.app.goToStore'
      defaultMessage='VAI ALLO STORE'
    />
  ),
  appRootedModalTitle: (
    <PortalMessage
      id='t.app.errorModal.appRootedModalTitle'
      defaultMessage='Ci dispiace ma il tuo device non è supportato.'
    />
  ),
  appRootedModalDescription: (
    <>
      <PortalMessage
        id='t.app.errorModal.appRootedModalDescription1'
        defaultMessage='Per accedere a Nexi Business puoi utilizzare il sito '
      />
      <PortalTextLink
        id='server-link'
        label='https://business.nexi.it'
        onClick={() => openUrl('https://business.nexi.it')}
        underline='always'
        isTargetBlank
      />
      <PortalMessage
        id='t.app.errorModal.appRootedModalDescription2'
        defaultMessage=' con le tue credenziali, anche da mobile'
      />
    </>
  ),
  appSslInvalidModalTitle: (
    <PortalMessage
      id='t.app.errorModal.appSslInvalidModalTitle'
      defaultMessage='Connessione non sicura'
    />
  ),
  appSslInvalidModalDescription: (
    <PortalMessage
      id='t.app.errorModal.appSslInvalidModalDescription'
      defaultMessage='Servizio non disponibile, riprovare più tardi'
    />
  ),
  blockedMFATitle: (
    <PortalMessage
      id='t.app.errorModal.blockedMFATitle'
      defaultMessage='La tua utenza è stata bloccata'
    />
  )
}

export default formattedMessage
